export enum LeadDetailsAccordion {
  PropertyLocation = "Property location",
  LoanScenario = "Loan scenario",
  Misc = "Misc.",
  Message = "Message"
}
